import * as React from 'react'
import Card from 'react-bootstrap/Card'
import { useSelector } from 'react-redux'
import { Link } from 'react-router-dom'
import { landlordActions } from './store'
import AddressForm from './AddressForm'
import PersonalInfoForm from './PersonalInfoForm'

const LandlordInfo = () => {
  const person = useSelector(state => state.landlord)
  return (
    <div>
      <Card>
        <Card.Header>ข้อมูลผู้ให้เช่า</Card.Header>
        <Card.Body>
          <PersonalInfoForm person={person} actions={landlordActions}/>
        </Card.Body>
      </Card>
      <Card>
        <Card.Header>ที่อยู่ผู้ให้เช่า</Card.Header>
        <Card.Body>
          <AddressForm address={person.address} actions={landlordActions}/>
        </Card.Body>
      </Card>
      <div className="d-grid gap-2 button-group">
        <Link
          className="btn btn-danger btn-md"
          role="button"
          to="/tenant"
        >
          ถัดไป
        </Link>
        <Link
          className="btn btn-secondary btn-md"
          role="button"
          to="/property"
        >
          ย้อนกลับ
        </Link>
      </div>
    </div>
  )
}

export default LandlordInfo
